import {buildCst} from './syntax-tree/build-syntax-tree'
import type {CstNode} from './syntax-tree/syntax-tree'
import {tokenize} from './tokenize/tokenize-markdown'

export function parseMarkdown(markdown: string): CstNode {
  const tokens = tokenize(markdown)
  return buildCst(tokens, markdown)
}
